export const ARRAY_LIMIT = 6;
